import { safetyHandler } from './utils';

export const CookieName = new Proxy(
  {
    ACCEPTED_COOKIE_POLICY: 'ldt_accepted_cookie_policy',
  },
  safetyHandler('CookieName'),
);

export const verifyCookieName = (name) => {
  if (!Object.values(CookieName).includes(name)) {
    throw new Error(`Attempted get value for invalid cookie [${name}]`);
  }
};

export const transformCookieValue = (name, value) => {
  switch (name) {
    case CookieName.ACCEPTED_COOKIE_POLICY:
      return value === true || value === 'true'; // boolean value
    default:
      return value;
  }
};
